<template>
  <div class="tw-p-6 tw-flex tw-items-center">
    <img :src="user.display_avatar" alt="" class="tw-w-16 tw-h-16 tw-rounded-full">
    <div class="tw-flex-1 tw-ml-4">
      <a :href="user.url" class="tw-font-semibold hover:tw-text-blue">{{user.name}}</a>
      <div class="tw-text-gray-600">{{'@' + user.username}}</div>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>

</template>
<script>
  export default {
    props: {
      user: {},
    }
  }
</script>
